(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name crewing.constant:crewingConstants
   *
   * @description
   *
   */
  angular
    .module('crewing')
    .value('crewingConstants', {
        EVENT_TYPES : {
          off : 'OFF',
          sickLeave : 'SLV',
          annualLeave : 'ALV',
          blockDays : 'BLK',
          cnt:'CNT',
          vulvLeave: 'VULV',
          ulvLeave: 'ULV',
          elvLeave: 'ELV',
          indLeave: 'IND',
          hajLeave: 'HAJ',
          comLeave: 'COM',
          matLeave: 'MAT',
          patLeave: 'PAT',
          uslLeave: 'USL',
          marLeave: 'MAR',
          susLeave: 'SUS',
          nshLeave: 'NSH',
          absLeave: 'ABS',
          clvLeave: 'CLV',
          sulvLeave: 'SULV',
          fmLeave: 'FM',
          fslvLeave: 'FSLV',
          snyLeave: 'SNY',
          officeDuty:'OFC',
          wfdLeave:'WFD',
          awbLeave:'AWB',
          limLeave:'LIM',
          vunpLeave:'VUNP',
          sbdLeave:'SBD',
          secondedinOtherHubs:'SOH',
          cabinSpecialDuty :'CSD',
          cabinSupportActivity:'CSA',
          available:'AVL',
          toBeNotified:'TBN'
        }
    });
}());
